(() => {
  /** @type {any} */
  const windowAny = window;
  /** @type {any} */
  const recommendationsUtils = windowAny.EcommRecommendationsUtils;
  /** @type {any} */
  const algorithmApi = windowAny.EcommRecommendationsAlgorithm;
  if (!recommendationsUtils || !algorithmApi) {
    return;
  }

  function addRecommendationLoader() {
    if (document.getElementById('load-container')) return false;

    const loadContainer = document.createElement('div');
    loadContainer.className = 'load-container';
    loadContainer.id = 'load-container';

    const loadSpinner = document.createElement('div');
    loadSpinner.className = 'load';

    loadContainer.appendChild(loadSpinner);
    document.body.appendChild(loadContainer);
    return true;
  }

  /**
   * @param {boolean} ownsLoader
   */
  function removeRecommendationLoader(ownsLoader) {
    if (!ownsLoader) return;
    window.setTimeout(() => {
      document.querySelectorAll('#load-container').forEach((loader) => loader.remove());
    }, 150);
  }

  /**
   * @param {string} profileKey
   * @param {() => void} [onComplete]
   */
  function reorderEcommGuestRecommendationsWithLoader(profileKey, onComplete) {
    const ownsLoader = addRecommendationLoader();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          reorderEcommGuestRecommendations(profileKey);
        } finally {
          removeRecommendationLoader(ownsLoader);
          if (typeof onComplete === 'function') onComplete();
        }
      });
    });
  }

  let guestReorderMergeProfileKey = '';
  let guestReorderMergeLoader = false;
  /** @type {number} */
  let guestReorderRafId = 0;
  let guestReorderChainActive = false;

  /**
   * @param {string} profileKey
   * @param {boolean} withLoader
   */
  function requestGuestReorder(profileKey, withLoader) {
    const pk = String(profileKey || '').trim();
    if (pk) guestReorderMergeProfileKey = pk;
    guestReorderMergeLoader = guestReorderMergeLoader || Boolean(withLoader);

    if (guestReorderChainActive) return;

    if (guestReorderRafId) cancelAnimationFrame(guestReorderRafId);
    guestReorderRafId = requestAnimationFrame(() => {
      guestReorderRafId = 0;
      guestReorderChainActive = true;
      runGuestReorderChainStep();
    });
  }

  function runGuestReorderChainStep() {
    const pkOut = guestReorderMergeProfileKey;
    const loaderOut = guestReorderMergeLoader;
    guestReorderMergeProfileKey = '';
    guestReorderMergeLoader = false;

    const afterStep = () => {
      if (guestReorderMergeProfileKey || guestReorderMergeLoader) {
        runGuestReorderChainStep();
      } else {
        guestReorderChainActive = false;
      }
    };

    if (loaderOut) {
      reorderEcommGuestRecommendationsWithLoader(pkOut, afterStep);
    } else {
      try {
        reorderEcommGuestRecommendations(pkOut);
      } finally {
        afterStep();
      }
    }
  }

  // profileKeyFromEvent is the profile key (e.g. "p1", "p2", "p3") from the event detail
  /**
   * @param {string} profileKeyFromEvent
   */
  function reorderEcommGuestRecommendations(profileKeyFromEvent) {
    // console.log(`[ECOMM][GUEST] reorderEcommGuestRecommendations:start for profile key: ${profileKeyFromEvent}`);

    // Check if the <li> element inside of main-collection.liquid has data-ecomm-profile-key="guest" ( which means that it is a guest recommendation item )
    // This will be used when a user is logged out
    const guestItems = Array.from(
      document.querySelectorAll('[data-ecomm-recommendation-item][data-ecomm-profile-key="guest"]')
    ).filter((el) => el instanceof HTMLElement);

    // If there are no guest items, return
    if (!guestItems.length) {
      return;
    }

    // Persist a stable original order once.
    guestItems.forEach((el, i) => {
      if (!el.dataset.ecommOriginalIndex) el.dataset.ecommOriginalIndex = String(i);
    });

    // Passing the same guestItems order
    guestItems.sort((a, b) => {
      const ai = Number(a.dataset.ecommOriginalIndex || '0');
      const bi = Number(b.dataset.ecommOriginalIndex || '0');
      return ai - bi;
    });

    // Get the active profile key from the input[name="ecomm-profile"]:checked
    let activeProfileKey = String(profileKeyFromEvent || '').trim();
    if (!activeProfileKey) {
      const checked = document.querySelector('input[name="ecomm-profile"]:checked');
      if (checked instanceof HTMLInputElement) activeProfileKey = checked.value;
    }

    // console.log('[ECOMM][GUEST] activeProfileKey', { activeProfileKey });

    if (!activeProfileKey) {
      return;
    }

    // Read the churned recommendations ordered product ids for the given profile key
    // So if you add your email address, and if under that email address you have your recommendations provided by churned
    // Then we save those recommendations ( product ids ) in the sessionStorage under the key "churned_recommendations"
    const churnedOrderedIds =
      typeof recommendationsUtils.readChurnedRecommendationOrderedIds === 'function'
        ? recommendationsUtils.readChurnedRecommendationOrderedIds(activeProfileKey, '[ECOMM][GUEST]')
        : [];

    // Read survey payload:
    // - Priority: logged-in customer metafield JSON embedded in the page
    //   <script type="application/json" data-ecomm-mijn-gegevens-json>...</script>
    // - Fallback: guest sessionStorage ( under the key "recommendations" )
    const sessionPayloadRaw = sessionStorage.getItem('recommendations');
    let payload = null;

    const hasMijnGegevensEl = document.querySelector('[data-ecomm-mijn-gegevens-json]') instanceof HTMLElement;
    if (hasMijnGegevensEl) {
      payload = recommendationsUtils.readJsonFromScriptTag('[data-ecomm-mijn-gegevens-json]', '[ECOMM][GUEST]');
      // console.log('[ECOMM][GUEST] payload source', { source: 'data-ecomm-mijn-gegevens-json', hasMijnGegevensEl });
    } else if (sessionPayloadRaw) {
      try {
        payload = JSON.parse(sessionPayloadRaw || '{}');
      } catch (error) {
        // console.warn('[ECOMM][GUEST] failed to parse sessionStorage recommendations', error);
        payload = null;
      }
      // console.log('[ECOMM][GUEST] payload source', { source: 'sessionStorage', hasSession: true });
    } else {
      // console.log('[ECOMM][GUEST] payload source', { source: 'none', hasMijnGegevensEl: false, hasSession: false });
      // console.log("Recommendations")
    }

    // Build the picker context from the payload
    // Picker means that we are going to pick the best items for the profile from the payload ( recommendations )
    // This picker returns a context object that contains the profile, the preferred diet order tokens, and the preferences
    // The preferences are the diet tokens, the kitchen tokens, the portion grams, the meal slots, the meals count, the soup count, and the dessert count
    const pickerContext =
      typeof recommendationsUtils.buildThuysVersRecommendationPickerContextFromPayload === 'function'
        ? recommendationsUtils.buildThuysVersRecommendationPickerContextFromPayload(payload, activeProfileKey)
        : null;
    if (!pickerContext) {
      return;
    }

    // The preferred diet order tokens are the tokens that we are going to use to order the items
    const preferredDietOrderTokens = pickerContext.preferredDietOrderTokens;
    // The prefs are the preferences that we are going to use to order the items
    const prefs = pickerContext.prefs;
    // The profile portion grams for rest is the portion grams that we are going to use to order the rest of the items
    const profilePortionGramsForRest =
      typeof recommendationsUtils.parseProfilePortionGramsFromSurveyProfile === 'function'
        ? recommendationsUtils.parseProfilePortionGramsFromSurveyProfile(pickerContext.profile)
        : null;

    // The list parent is the parent element of the guest items ( <ul> element inside of main-collection.liquid )
    const listParent = guestItems[0]?.parentElement;
    if (!(listParent instanceof HTMLElement)) return;

    // Apply churned ids as a priority ordering input
    const guestItemsForPicker =
      typeof recommendationsUtils.prioritizeElementsByProductId === 'function'
        ? recommendationsUtils.prioritizeElementsByProductId(guestItems, churnedOrderedIds)
        : guestItems;

    // This is the algorithm that will pick the best items for the profile from the payload ( recommendations )
    // Pick the guest metaobject items for meal/soup/dessert and return an ordering, applying algorithm logic
    const pickResult = algorithmApi.pickMealsAndExtrasBasedOnProfileKeyPreference(guestItemsForPicker, prefs);

    // This is the function that will apply the picker result to the guest items
    const applied =
      typeof recommendationsUtils.applyPickerResultToRecommendItems === 'function'
        ? recommendationsUtils.applyPickerResultToRecommendItems(guestItems, pickResult, preferredDietOrderTokens, profilePortionGramsForRest)
        : { orderedItems: [...pickResult.orderedChosen, ...pickResult.orderedRest], pickedProductIdSet: new Set() };

    // The next dom order is the ordered items that will be appended to the list parent
    const nextDomOrder = applied.orderedItems;
    // Create a document fragment to append the ordered items to the list parent
    const fragment = document.createDocumentFragment();
    // Append the ordered items to the document fragment
    nextDomOrder.forEach((/** @type {HTMLElement} */ element) => fragment.appendChild(element));
    // Keep picked guest recommendations at the top of the loaded grid, including after infinite-scroll appends.
    listParent.prepend(fragment);

    // Apply the badges to ALL items in the list, not just guest recommendation items, so products matching selectedDietLabels get badges
    const selectedDietLabels = pickerContext.selectedDietLabels;
    // console.log(`[ECOMM][GUEST] applying badges for profile key: ${activeProfileKey}`, { selectedDietLabels });
    // This is the function that will apply the badges to all items ( diet badges )
    const allItemsForBadges = Array.from(listParent.children).filter((el) => el instanceof HTMLElement);
    if (typeof recommendationsUtils.applyRecommendationBadges === 'function') {
      recommendationsUtils.applyRecommendationBadges(allItemsForBadges, selectedDietLabels);
    }

  }

  // Trigger on profile change (from ecomm-recommendations-utility.js)
  // This is the event that will be triggered when the profile is changed
  // It will trigger the reorderEcommGuestRecommendations function with the profile key
  window.addEventListener('ecomm-profile-changed', (event) => {
    const detail = /** @type {any} */ (event)?.detail || {};
    // console.log('[ECOMM][GUEST] ecomm-profile-changed event', detail);
    const source = String(detail.source || '');
    requestGuestReorder(String(detail.profileKey || ''), source === 'change');
  });

  // Re-apply guest recommendation ordering when infinite scroll appends more rows.
  window.addEventListener('collection-page-appended', () => {
    requestGuestReorder('', false);
  });

  document.addEventListener('collection-results-rendered', () => {
    requestGuestReorder('', false);
  });

  // Initial run covers pages where the person toggle has already selected a profile.
  requestGuestReorder('', false);

  // After listeners are registered: guarantee ecomm-profile radios dispatch `ecomm-profile-changed`
  // (quick-filters may have skipped initPersonToggleLogger when payload was missing on first sync).
  const bindToggle = () => recommendationsUtils.ensurePersonToggleRecommendationDispatchBound?.();
  requestAnimationFrame(() => requestAnimationFrame(bindToggle));
  document.addEventListener('collection-results-rendered', bindToggle);
})();
